<template>
    <div>
        <div class="row mb-4">
            <div class="col-12 col-md-10 mb-3">
                <!-- <button @click="itemModal = '5487.6.5806', showModalItem = true">Teste</button> -->
                <div class="testePopUp" :style="displayQrCode">
                    <video id="video"></video>
                    <button class="btn btnCloseQrCode" @click="displayQrCode = 'display:none;'">X</button>
                </div>
                <input type="text" class="form-control" :placeholder="$t('Pesquisar Item')" v-model="itemFiltro"
                    style="height: 53px;" aria-describedby="btn-limpar-filtro">
            </div>
            <div class="col-12 col-md-2 d-flex ">
                <button class="btn btn-outline-info mr-2 icones" v-if="limparFiltro" style="font-size: 18px;" @click="clearFilter()">
                    <i class="fas fa-times"></i>
                </button>
                <button class="btn btn-outline-info mr-2 icones" style="font-size: 18px;" @click="searchItem()">
                    <i class="fas fa-search"></i>
                </button>
                <button class="btn btn-outline-success icones" @click="qrCode()">
                    <i class="fa fa-camera" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <table class="table table-striped tabelaInventario">
            <thead>
                <tr>
                    <th scope="col">{{ $t('codigo') }}</th>
                    <th scope="col">{{ $t('Item') }}</th>
                    <th scope="col">{{ $t('Localização') }}</th>
                    <th scope="col">{{ $t('saldo_atual') }}</th>
                    <th scope="col">{{ $t('Quantidade') }}</th>
                    <th scope="col">{{ $t('Ação') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(inventario, index) in inventarios" :key="index">
                    <td>{{ inventario.ds_codigoitem }}</td>
                    <td>{{ inventario.ds_item.substring(0, 30) }}</td>
                    <td>{{ inventario.ds_localizacao_item }}</td>
                    <td>{{ Math.trunc(inventario.saldo_atual) }}</td>
                    <td>{{ Math.trunc(inventario.nr_qtidade) }}</td>
                    <th scope="row"><button class="btn"
                            @click="itemModal = inventario.ds_codigoitem, showModalItem = true"
                            :disabled="inventario_atual"><i
                                class="fa fa-pen"></i></button></th>
                </tr>
            </tbody>
        </table>

        <div class="mb-3 d-flex justify-content-right">
            <span>
                <span v-if="items !== 'loading' && items.total > 0">
                    {{ $t('Exibindo resultado') }}
                    <span class="badge badge-light" style="font-size:18px">{{ items.from }} <span
                            class="font-weight-normal">a</span>
                        {{ items.to }}</span>
                    {{ $t('de') }}
                    <span class="badge badge-warning" style="font-size:18px">{{
                        items.total
                    }}</span>
                </span>
                <span class="w-100 text-center" v-if="items !== 'loading' && !items.total">
                    {{ $t('Nenhum resultado encontrado') }}.
                </span>
                <!-- {{ $t('Total Itens') }}: <span class="badge" style="font-size:18px">{{ totalItens }}</span> -->
            </span>
        </div>




        <!-- <div class="col-12 d-flex justify-content-center mt-2 mb-5">
            <os-pagination position="bottom"></os-pagination>
        </div> -->
        <!-- <b-button v-b-modal.modal-xl variant="primary">xl modal</b-button> -->

        <modal-item-inventario v-if="showModalItem" @closeModal="showModalItem = false" :item="itemModal">
        </modal-item-inventario>

    </div>
</template>
<script>
/* eslint-disable */

import OsPagination from '@/components/OsPagination'
import ModalItemInventario from './ModalItemInventario'

export default {
    components: {
        OsPagination,
        ModalItemInventario
    },

    data() {
        return {
            showModalItem: false,
            screenQrCode: false,
            displayQrCode: 'display:none',
            itemModal: null,
            itemFiltro: '',
            limparFiltro: false,
            inventario_atual: false
        }
    },

    computed: {
        totalItens() {
            return this.$store.getters['inventario/getTotalItens']
        },

        inventarios() {
            const inventarios = this.$store.getters['inventario/getItensInventarioTemp']


            if (!inventarios) {

                const data = {
                    nr_seq_inventario: this.$route.params.id
                }

                this.$store.dispatch('inventario/getItensInventario', { data: data })
            }

            return inventarios
        },
        items() {
            return this.$store.getters['inventario/getDataItems']
        },
    },

    methods: {
        searchItem() {
            const data = {
                ds_search: this.itemFiltro.toUpperCase(),
                nr_seq_inventario: this.$route.params.id
            }

            this.$store.dispatch('inventario/filtrarItemPorPalavra', { data: data })
            this.limparFiltro = true
        },
        clearFilter() {
            this.limparFiltro = false
            this.itemFiltro = ''
            const data = {
                nr_seq_inventario: this.$route.params.id
            }
            this.getItensInventario(data)
            // this.$store.dispatch('inventario/filtrarItemPorPalavra', { palavra: this.itemFiltro })
        },

        async qrCode() {
            this.displayQrCode = 'display:flex'

            const scanner = new Instascan.Scanner({
                video: document.querySelector('#video')
            })

            scanner.addListener('scan', content => {
                this.displayQrCode = 'display:none;'
                this.itemModal = content
                this.showModalItem = true

                scanner.stop()
            })

            Instascan.Camera.getCameras().then((cameras) => {
                let selectedCamera;

                if (cameras.length > 0) {
                    // scanner.start(cameras[2]);
                    for (let c = 0; c < cameras.length; c++) {
                        if (cameras[c].name.indexOf('back') != -1) {
                            selectedCamera = cameras[c];
                        }
                    }

                    if (!selectedCamera) selectedCamera = cameras[0];
                    scanner.start(selectedCamera);
                } 

                if (selectedCamera) {
                    scanner.start(selectedCamera);
                } else {
                    console.error("No cameras found.");
                }
            })
        },

        getItensInventario(data) {
            this.$store.dispatch('inventario/getItensInventario', { data: data })
        },

        getInventario(){
            this.$store.dispatch('inventario/getInventarios').then(resp => {
                this.$store.dispatch('inventario/searchInventario', { data: this.$route.params.id }).then(response => {
                    if(response.st_etapa == 'finalizado'){
                        this.inventario_atual = true
                    }
                })
            })
        }
    },

    created() {
        const data = {
            nr_seq_inventario: this.$route.params.id
        }

        this.getItensInventario(data)

        this.getInventario()
    }
}
</script>
<style src="./style.css" lang="css"></style>